import React from 'react';
import PropTypes from 'prop-types';
import FormControl from './FormControl';
import AceEditor from 'react-ace';
import 'brace/mode/json';
import 'brace/mode/css';
import 'brace/theme/monokai';

export default class CodeEditor extends FormControl {
  static propTypes = {
    onChange: PropTypes.func,
    onValueChange: PropTypes.func,
    dataValue: PropTypes.any
  };

  constructor(props) {
    super(props);
    let value;
    if(props.dataValue){
      if (props.mode === 'json') {
        value = this.formatJson(props.dataValue);
      } else {
        value = props.dataValue;
      }
    }
    this.state = {
      value
    };
  }

  formatJson = (json) => {
    let jsonData;
    try {
      jsonData = JSON.parse(json);
    } catch (e) {
      jsonData = {};
    }
    return JSON.stringify(jsonData, null, 2);
  }

  onChange = (value, skipValueChange) => {
    this.setState({ value });
    if (typeof this.props.onChange === 'function'){
      this.props.onChange(value);
    }
    if (typeof this.props.onValueChange === 'function' && !skipValueChange){
      this.props.onValueChange({ [this.props.name]: value });
    }
  }

  render() {
    const { name, mode, disabled } = this.props;

    return (
      <div>
        <AceEditor
          theme="monokai"
          mode={mode}
          name={name}
          onChange={this.onChange}
          readOnly={disabled}
          value={this.state.value}
          fontSize={14}
          height={'300px'}
          showPrintMargin={false}
          showGutter={false}
          highlightActiveLine={true}
          setOptions={{
            enableBasicAutocompletion: false,
            enableLiveAutocompletion: false,
            enableSnippets: false,
            showLineNumbers: false,
            tabSize: 2
          }}/>
        <input type="hidden" id={`${name}_input`} value={this.state.value} name={name} disabled={disabled} ref={(input) => (this.input = input)}/>
      </div>
    );
  }
}
